/**
 * Created by antonio on 16/02/15.
 */
define('payment/templates/deposit-sender',['jquery', 'boxes/helpers/box-loading', 'boxes/helpers/payment-sender-helper', 'all/pretty-links', 'all/paymentServices-toggles'], function ($, boxLoading, paymentSenderHelper, prettyLinks, paymentServicesToggles) {
    'use strict';


    function verifyAge(depositBox) {
        var amount = depositBox.$box.find('.amount-box').find('input').val();
        var paymentMethodId = depositBox.model.paymentController.selectedFormMethodId;

        var data = {
            am: amount,
            paymentMethod: paymentMethodId,
            cu: 'USERSESSIONS_CURRENCY'
        };

        if(typeof(depositBox.model.paymentController.selectedCurrency) !== 'undefined') {
            data.cu = depositBox.model.paymentController.selectedCurrency;
        }

        return $.ajax({
            url: '/UkComplianceService/verifyAgeService',
            data: data
        });
    }

    function showVerifyAgeError(depositBox, verifyAgeData) {
        boxLoading.removeLoading(depositBox.$box);
        depositBox.model.showVerifyAgePopup(depositBox, {
            title: verifyAgeData.ERROR_HEADER,
            message: verifyAgeData.ERROR,
			confirmButtonText: verifyAgeData.BUTTON_TEXT,
            closeButtonText: verifyAgeData.CLOSE
        },
		{
			confirmButtonCallback: function(){
				window.location.href = prettyLinks.getLink('MyPages', 'SendDocuments');
			}
		}
		);
    }

    function verifyUKDepositTandCStatus(){
        return $.ajax({url:'/pp?flow=UKDepositTandCAgreementCheck'});
    }

    function updateUKTandCForDeposit(){
        return $.ajax({url:'/pp?flow=UKDepositTandCAgreementUpdate'});
    }

    function showVerifyUKDepositTandCStatus(depositBox,verificationData,formTemplate){
        boxLoading.removeLoading(depositBox.$box);
        depositBox.model.showUKDepositTandCStatus(depositBox,{
                title: verificationData.UK_DEPOSIT_TERMS_UPDATED_HEADER,
                message: verificationData.UK_DEPOSIT_TERMS_UPDATED,
                confirmButtonText: verificationData.AGREE
            },
            {
                closeButtonCallback: function(){
					depositBox.model.enableDepositButton(depositBox);
				},
                confirmButtonCallback: function(){
                    updateUKTandCForDeposit();
                    paymentSenderHelper.verifyAndSendPayment(depositBox, formTemplate, '/pp?flow=CheckDepositLimits');
                }
            }
        );
    }

    function checkUKDepositTandCStatusAndSendDeposit(depositBox,formTemplate){
        $.when(verifyUKDepositTandCStatus()).done(function(verificationData){
            if(verificationData.RESULT === 'OK'){
                paymentSenderHelper.verifyAndSendPayment(depositBox, formTemplate, '/pp?flow=CheckDepositLimits');
            }else{
                showVerifyUKDepositTandCStatus(depositBox, verificationData,formTemplate);
            }
        });
    }

    function send(formTemplate, depositBox) {
        // IMPORTANT: this has to be done before the ajax calls, otherwise popup window will be blocked
        formTemplate.sendHandler.init(formTemplate.paymentMethod.methodName);

        $.when(verifyAge(depositBox)).done(function (verifyAgeData) {
            if(verifyAgeData.RESULT === 'OK') {
                checkUKDepositTandCStatusAndSendDeposit(depositBox,formTemplate);
            } else {
                showVerifyAgeError(depositBox, verifyAgeData);
            }
        });
    }

    var depositSender = {};
    depositSender.send = send;
    return depositSender;
});

